<template>
  <div class="box">
    <img
      class="auth_img"
      v-if="userObj.userDataStatus < 3"
      src="//cdn.yxvzb.com/wechatfolder/image/%E4%B8%AA%E4%BA%BA%E4%B8%AD%E5%BF%83-%E7%BA%A2%E5%8C%85@2x.png"
      alt=""
    />
    <div class="doc_div">
      <div class="photo_div">
        <img class="photo" :src="userObj.headPhoto" alt="" />
        <img
          v-if="userObj.userDataStatus == 3"
          class="identIcon"
          src="//cdn.yxvzb.com/img/replyIsAuth.png"
          alt=""
        />
      </div>
      <div class="doc_right">
        <p class="doc_p1">{{ userObj.fullName || userObj.nickName }}</p>
        <p
          class="doc_p2"
          v-if="isWx && userObj.userDataStatus < 2"
          @click="toPerfect"
        >
          资料未完善
        </p>
        <p class="doc_p3" v-if="userObj.identId && userObj.hospitalName">
          <span v-if="userObj.departmentName">
            {{ userObj.departmentName }}
          </span>
          <span v-if="userObj.departmentName">|</span>
          <span v-if="userObj.dutyName">{{ userObj.dutyName }}</span>
        </p>
        <p class="doc_p3" v-if="userObj.identId && userObj.hospitalName">
          {{ userObj.hospitalName }}
        </p>
      </div>
      <p
        class="authP watingAuth"
        v-if="isWx && userObj.userDataStatus < 3"
        @click="toAuth"
      >
        待认证
      </p>
      <p class="authP " v-else-if="userObj.userDataStatus >= 3">已认证</p>
      <!--<p class="authP" v-else="userObj.isIdent">认证失败</p>-->
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    userObj: {
      type: Object,
      default: function() {
        return {};
      }
    },
    isWx: {
      default: true
    }
  },
  data() {
    return {
      auth: true
    };
  },
  methods: {
    toPerfect() {
      /*
       * goBackUrl  perfect 完善信息或者实名认证后 回跳地址
       * */
      sessionStorage.goBackUrl = '/html/newWechat.html';
      location.href = '/html/perfect.html#/perfect';
    },
    toAuth() {
      sessionStorage.goBackUrl = '/html/newWechat.html';
      location.href = '/html/perfect.html#/verifi';
    }
  },
  computed: {},
  components: {},
  mounted() {}
};
</script>
<style lang="less" scoped>
.box {
  padding: 0.4rem;
  background: #ffffff;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  position: relative;
  .auth_img {
    width: 95%;
    display: block;
    margin: auto;
    margin-top: 0.106rem;
    margin-bottom: 0.466rem;
    /*height: .533rem;*/
  }
  .doc_div {
    display: flex;
    align-items: center;
    height: 1.466rem;
    position: relative;
    .photo_div {
      width: 1.466rem;
      height: 1.466rem;
      border-radius: 50%;
      position: relative;
      margin-right: 0.266rem;
      .photo {
        border-radius: 50%;
      }
      .identIcon {
        width: 0.5rem;
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }
    .doc_right {
      /*align-self: flex-start;*/
      .doc_p1 {
        font-size: 0.4266rem;
      }
      .doc_p2 {
        font-size: 0.32rem;
        color: #027cfa;
      }
      .doc_p3 {
        font-size: 0.32rem;
        color: #999;
        span:nth-of-type(2) {
          margin: 0.16rem;
        }
      }
    }
  }
  .authP {
    position: absolute;
    right: 0;
    top: 0;
    color: #027df9;
    border-radius: 0.08rem;
    padding: 0.08rem 0.2133rem;
  }
  .watingAuth {
    border: 1px solid #027df9;
  }
}
</style>
